import Cookies from 'js-cookie'
import { segment } from 'util/analytics'
import { post } from 'util/api'
import { logError } from 'util/error'
import { getReferrerData, setReferrerCookie } from 'util/referrer'

export default function trackHit(data) {
  if (!data && !data.gatheringId && !data.schoolId) {
    logError('Missing school or gathering ID for hit', data)
    return
  }

  setReferrerCookie()

  const hit = {
    ...data,
    referrer: getReferrerData(),
    segmentAnonymousId: getSegmentAnonymousId(data),
  }

  post('/api/hits', { hit }).catch(response => logError('Error tracking page', response))
}

function getSegmentAnonymousId(data) {
  // Cookie set by analytics.js (Segment)
  const value = Cookies.get('ajs_anonymous_id')

  if (!value) {
    segment.track('No ajs_anonymous_id found', { ...data, url: window.location.href })
  } else {
    segment.track('ajs_anonymous_id found', { ...data, anonId: value, url: window.location.href })
  }

  try {
    return JSON.parse(value)
  } catch (e) {
    return null
  }
}
